import { isMacOS } from './app';

enum Key {
  Y = 'y',
  Z = 'z',
}

export const undoKeyCommand = isMacOS() ? '⌘Z' : 'Ctrl+Z';
export const redoKeyCommand = isMacOS() ? '⇧⌘Z' : 'Ctrl+Y';

// Note: Should always check for event.key (instead of event.code) to support different keyboard layouts
const isKey = (event: KeyboardEvent, key: Key) =>
  event.key.toLowerCase() === key;

export const hasPressedUndo = (event: KeyboardEvent) => {
  return isMacOS()
    ? !event.shiftKey && event.metaKey && isKey(event, Key.Z)
    : !event.shiftKey && event.ctrlKey && isKey(event, Key.Z);
};

export const hasPressedRedo = (event: KeyboardEvent) => {
  return isMacOS()
    ? event.shiftKey && event.metaKey && isKey(event, Key.Z)
    : (!event.shiftKey && event.ctrlKey && isKey(event, Key.Y)) ||
        (event.shiftKey && event.ctrlKey && isKey(event, Key.Z));
};

export const hasPressedUndoOrRedo = (ev: React.KeyboardEvent) =>
  hasPressedUndo(ev.nativeEvent) || hasPressedRedo(ev.nativeEvent);

export const hasPressedArrowKey = (ev: React.KeyboardEvent) =>
  ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(ev.key);
